import { render } from "./PrcMobileApp1.vue?vue&type=template&id=d1ebcd92&scoped=true"
import script from "./PrcMobileApp1.vue?vue&type=script&lang=js"
export * from "./PrcMobileApp1.vue?vue&type=script&lang=js"

import "./PrcMobileApp1.vue?vue&type=style&index=0&id=d1ebcd92&lang=less&scoped=true"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1ebcd92"]])

export default __exports__